import classNames from 'classnames/bind';
import { useFormikContext } from 'formik';
import React from 'react';

import { Select } from '@components/Input/Select';
import { estimatedTraffic } from '@containers/Validator/validator';

import styles from './EstimatedTrafficSelect.module.scss';

export const estimatedTrafficValues = [
  { label: '1 TB - 250 TB', value: '1-250' },
  { label: '250 TB - 3 PB', value: '250-3000' },
  { label: '3 PB - 10 PB', value: '3000-10000' },
  { label: '10 PB - 50 PB', value: '10000-50000' },
  { label: '50 PB - 250 PB', value: '50000-250000' },
  { label: '250 PB+', value: '250000-*' },
] as const;

const cx = classNames.bind(styles);

export const EstimatedTrafficSelect: React.FC = () => {
  const { values } = useFormikContext<{ estimatedTraffic: string }>();

  return (
    <Select
      className={cx({ noValueSelected: values.estimatedTraffic === '' })}
      id="estimated-traffic"
      label="Monthly traffic estimate"
      name="estimatedTraffic"
      tooltipText="Estimated monthly traffic volume is for informative purposes only without any commitment."
      validate={estimatedTraffic}
    >
      <option value="" disabled>
        — choose estimate
      </option>
      <>
        {estimatedTrafficValues.map(({ label, value }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </>
    </Select>
  );
};
